module.exports = __webpack_public_path__ + "static/media/preview_screen4.90a03558.png";